/// <summary>
/// 제어 코드
/// </summary>
export enum EControlCode {
  /// <summary>
  /// 포트 초기화
  /// </summary>
  PORT_INITIATE,
  /// <summary>
  /// 포트 열기
  /// </summary>
  PORT_OPEN,
  /// <summary>
  /// 포트 폐쇄
  /// </summary>
  PORT_CLOSE,
  /// <summary>
  /// 포트 한번 열기
  /// </summary>
  PORT_OPEN_ONCE,
  /// <summary>
  /// 포트 일반 상태로 전환
  /// </summary>
  BACK_TO_NORMAL_STATUS,
  /// <summary>
  /// 스케줄 일시 정지
  /// </summary>
  SUSPEND_TIME_SCHEDULE,
  /// <summary>
  /// 스케줄 재개
  /// </summary>
  RESUME_TIME_SCHEDULE,

  /// <summary>
  /// 센서 기능 활성화
  /// </summary>
  ACTIVATE_SENSOR_FUNC = 10,
  /// <summary>
  /// 센서 기능 비 활성화
  /// </summary>
  DEACTIVATE_SENSOR_FUNC,
  /// <summary>
  /// 관리자에 의한 센서 연동 Relay 포트 활성 화
  /// </summary>
  ACTIVATE_SENSOR_LINKED_RELAY,
  /// <summary>
  /// 관리자에 의한 센서 연동 Relay 포트 비 활성 화, 관리자에 의한 센서 감지 상태 해제 (센서 해제 모드가 관리자 감지 해제 인 경우)
  /// </summary>
  DEACTIVATE_SENSOR_LINKED_RELAY,
  /// <summary>
  /// 센서 스케줄 일시 정지
  /// </summary>
  SUSPEND_SENSOR_SCHEDULE,
  /// <summary>
  /// 센서 스케줄 재개
  /// </summary>
  RESUME_SENSOR_SCHEDULE,

  /// <summary>
  /// 접점 ON
  /// </summary>
  CONTACT_ON = 20,
  /// <summary>
  /// 접점 OFF
  /// </summary>
  CONTACT_OFF,
  /// <summary>
  /// 접점 스케줄 일시 정지
  /// </summary>
  SUSPEND_CONTACT_SCHEDULE,
  /// <summary>
  /// 접점 스케줄 재개
  /// </summary>
  RESUME_CONTACT_SCHEDULE
}
